module.exports = __webpack_public_path__ + "img/phone.e7c0df98.png";